import { GzPolicyPanelAccordionNavigationHeaderWebComponent } from './component/GzPolicyPanelAccordionNavigationHeaderWebComponent';

export { GzPolicyPanelAccordionNavigationHeaderWebComponent };
